import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StationService } from 'src/app/_services/station.service';
import { LoaderService } from 'src/app/loader.service';
import { Observable, Subscription, timer } from 'rxjs';
import { AgmMap } from '@agm/core';
import { AgmMarkerCluster } from '@agm/js-marker-clusterer';
import { SnackbarService } from '../../_service/message-service';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ChargeBoxService } from 'src/app/_services/chargebox/chargebox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { ActualRole, Role } from 'src/app/util/enums/role.enum';
import { MenuRouteID } from '../header/menu-item/nav-item';
import { AuthenticationService } from '../../_services';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { RouteConstants } from 'src/app/util/route.constants';
import { Position } from 'ngx-mapbox-gl';

@Component({
  selector: 'telio-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss']
})

export class MapViewComponent implements OnInit, AfterViewInit, OnDestroy {
  lat = environment.branding.mapInfo.lat;
  lng = environment.branding.mapInfo.lng;
  public iconUrl = { url: './assets/images/telioevmapsiconnew.png', scaledSize: { height: 43, width: 33 } }
  @ViewChild('AgmMap', { static: false }) agmMap: AgmMap;
  @ViewChild(AgmMarkerCluster, { static: false }) markerCluster: AgmMarkerCluster;
  stations: any = [];
  clusterStations: any[] = [];
  showClusterList = false;
  /** True when station details were opened from the cluster list (show back). */
  openedFromClusterList = false;
  private clusterClickBound = false;
  private clusterClickBinding = false;
  private boundClusterer: any = null;
  private mapCenterLat = environment.branding.mapInfo.lat;
  private mapCenterLng = environment.branding.mapInfo.lng;
  private currentZoom = 5;
  private pendingClusterListFromClick = false;
  private stationByChargeboxId = new Map<string, any>();
  private stationByPositionKey = new Map<string, any>();
  vendormailid: any;
  currentuser: any;
  zoom: number = 5;
  userStatus = false;
  stationListLoader = false;
  subscription: Subscription = new Subscription;
  loggedInStatus = false;
  private timer: Observable<any>;
  previous;
  currentlocation;
  isLoaded = false;
  flagDetails = false;
  stationFiltered: any = [];
  disableStationDetails = true;
  private reloadSub: Subscription;
  /** Toggled to destroy/recreate AGM map so MarkerClusterer cannot keep stale pins on reload. */
  showMap = true;
  stationColors = ['green', 'amber', 'orange', 'red', 'grey']

  constructor(
    private stationService: StationService,
    private userInfoService: UserInfoService,
    public loaderService: LoaderService,
    private toastr: SnackbarService,
    public translate: TranslateService,
    public chargeboxService: ChargeBoxService,
    readonly router: Router,
    private authenticationService: AuthenticationService,
    readonly breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.userInfoService.userDetails.prefCountry === 'LK' ? this.zoom = 9 : this.zoom = 5
    this.authenticationService.setShowButton(true);
    this.reloadSub = this.authenticationService.buttonClick$.subscribe(() => {
      this.onButtonClick();
    });
    this.getLocation();
    this.getStations();
    this.currentuser = this.userInfoService.userDetails;
    this.vendormailid = this.currentuser.email;

    this.loggedInStatus = !!sessionStorage.getItem('isLoggedIn') ? false : true
    if (this.loggedInStatus) {
      this.toastr.success(this.translate.instant('mapView.loginSuccess'));
      sessionStorage.setItem('isLoggedIn', 'false');
    }
  }

  ngAfterViewInit() {
    // Clusterer may not be ready yet; also retry from mapReady
    setTimeout(() => this.bindNativeClusterClick(), 0);
  }

  getStations() {
    if (this.userInfoService.isAdminGroup()) {
      this.getstationlist();
      this.setTimer()
    }
    else if (this.userInfoService.groups.includes(Role.CPO)) {
      this.currentuser = this.userInfoService.userDetails;
      this.vendormailid = this.currentuser.email;
      this.getstationlistbyvendorid(this.vendormailid);
    }
    else if (this.userInfoService.groups.includes(Role.SUBCPO) || this.userInfoService.groups.includes(Role.OPERATOR) ||this.userInfoService.groups.includes(Role.StationManager)) {
      this.currentuser = this.userInfoService.userDetails;
      this.vendormailid = this.currentuser.email;
      this.getstationlistbyvendorid(this.vendormailid);
    }
  }

  public setTimer() {
    this.stationListLoader = true;
    this.timer = timer(5000);
    // Must add to subscription — replacing it cancels/orphans the station list request
    this.subscription.add(this.timer.subscribe(() => {
      this.stationListLoader = false;
    }));
  }

  getstationlist() {
    this.subscription.add(this.stationService.getCmsStationList().pipe(map(events => {
      this.setStationsMap(events, true);
    })).subscribe());
  }

  getstationlistbyvendorid(id) {
    this.subscription.add(this.stationService.getstationlistbyvendorid(id).pipe(map(events => {
      this.setStationsMap(events.data, false);
    })).subscribe());
  }

  setStationsMap(events, type) {
    if (!!events && events.length > 0) {
      const mapped = events.map(event => {
        const latitude = Number(event.latitude);
        const longitude = Number(event.longitude);
        return {
          chargeboxId: event.chargeboxId,
          name: event.name || event.chargeboxId,
          latitude,
          longitude,
          originalLatitude: latitude,
          originalLongitude: longitude,
          iconUrl: !!event.chargeboxChargingStatusColour ? this.setIconURL(event.chargeboxChargingStatusColour) : this.setIconURL(this.stationColors[4])
        }
      });
      // Same lat/lng never unclusters on zoom — spread overlapping markers slightly
      this.stations = this.offsetOverlappingStations(mapped);
      this.rebuildStationLookup();
    }
    else {
      this.stations = [];
      this.stationByChargeboxId.clear();
      this.stationByPositionKey.clear();
    }
    this.cdr.detectChanges();
  }

  private rebuildStationLookup() {
    this.stationByChargeboxId.clear();
    this.stationByPositionKey.clear();
    (this.stations || []).forEach(station => {
      if (!station) {
        return;
      }
      if (station.chargeboxId != null) {
        this.stationByChargeboxId.set(String(station.chargeboxId), station);
      }
      if (Number.isFinite(Number(station.latitude)) && Number.isFinite(Number(station.longitude))) {
        this.stationByPositionKey.set(this.positionKey(station.latitude, station.longitude), station);
      }
    });
  }

  private positionKey(lat: number, lng: number): string {
    return `${Number(lat).toFixed(7)},${Number(lng).toFixed(7)}`;
  }

  /**
   * When multiple stations share identical coordinates, MarkerClusterer keeps them
   * as one cluster forever. Offset duplicates in a spiral so zoom/click works.
   */
  offsetOverlappingStations(stations: any[]): any[] {
    const groups = new Map<string, number[]>();
    stations.forEach((station, index) => {
      if (!Number.isFinite(station.latitude) || !Number.isFinite(station.longitude)) {
        return;
      }
      const key = `${station.latitude.toFixed(6)},${station.longitude.toFixed(6)}`;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key).push(index);
    });

    // ~40m base; grows for large groups (e.g. 40+ dummy stations)
    const baseOffsetDegrees = 0.0004;
    groups.forEach(indexes => {
      if (indexes.length < 2) {
        return;
      }
      const count = indexes.length;
      indexes.forEach((stationIndex, i) => {
        const angle = (2 * Math.PI * i) / count;
        const ring = Math.floor(i / Math.max(8, Math.ceil(Math.sqrt(count))));
        const radius = baseOffsetDegrees * (1 + ring * 0.9) * Math.max(1, Math.sqrt(count / 8));
        stations[stationIndex] = {
          ...stations[stationIndex],
          latitude: stations[stationIndex].latitude + radius * Math.cos(angle),
          longitude: stations[stationIndex].longitude + radius * Math.sin(angle)
        };
      });
    });
    return stations;
  }

  setIconURL(image: string) {
    let imgColor = this.checkInputColor(image) ? this.appendExtension(image) : this.appendExtension(this.stationColors[4]);
    return { url: `./assets/images/charging/${imgColor}`, scaledSize: { height: 43, width: 33 } };
  }

  clickedMarker($event, infowindow, chargeboxId) {
    this.showClusterList = false;
    this.openedFromClusterList = false;
    this.clusterStations = [];
    this.disableStationDetails = !this.userInfoService.isTabExists(MenuRouteID.STATIONS);
    if ($event.latitude > 84 || $event.latitude < -84) {
      this.lat = this.currentlocation.lat;
      this.lng = this.currentlocation.lng;
    } else if ($event.latitude < 84 && $event.latitude > -84) {
      this.currentlocation = { lat: $event.latitude, lng: $event.longitude }
    } else {
      this.currentlocation = { lat: this.lat, lng: this.lng }
    }
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
    this.stationService.getstationlistbyid(chargeboxId).subscribe((resp: any) => {
      this.setStationsMapDetails(resp);
    }, err => {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    });
  }

  setStationsMapDetails(events) {
    if (!!events) {
      let empty = 'NA';
      this.stationFiltered = {};
      this.stationFiltered.address = events.address ? events.address : empty;
      this.stationFiltered.chargeboxId = events.chargeboxId ? events.chargeboxId : empty;
      this.stationFiltered.latitude = events.latitude ? events.latitude : empty;
      this.stationFiltered.longitude = events.longitude ? events.longitude : empty;
      this.stationFiltered.name = events.name ? events.name : empty;
      this.stationFiltered.priceperunit = events.priceperunit ? events.priceperunit : empty;
      this.stationFiltered.status = events.status ? events.status : empty.toUpperCase();
      this.stationFiltered.type = events.type ? events.type : empty;
      this.stationFiltered.url = events.url ? events.url : empty;
      this.stationFiltered.activeStatus = (events.status.toLowerCase() == "available") ? "Active" : "Inactive",
        this.stationFiltered.userStatus = (events.status.toLowerCase() == "available"),
        this.stationFiltered.connectors = events.connectors.map(res => {
          return {
            availableConnectors: res.availableConnectors ? res.availableConnectors : empty,
            totalConnectors: res.totalConnectors ? res.totalConnectors : empty,
            portTypes: res.connectors.map(resp => {
              return resp.portType ? resp.portType : empty;
            })
          }
        }),
        this.stationFiltered.amenities = events.amenities ? events.amenities : empty;
      this.flagDetails = true;
    }
    else {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
      this.stationFiltered = [];
    }
  }

  close_window($event) {
    if ($event.coords.lat > 84 || $event.coords.lat < -84) {
      this.lat = this.currentlocation.lat;
      this.lng = this.currentlocation.lng;
    }
  }

  onMapReady() {
    this.bindNativeClusterClick();
  }

  onMapCenterChange(coords: { lat: number; lng: number }) {
    if (coords && Number.isFinite(coords.lat) && Number.isFinite(coords.lng)) {
      this.mapCenterLat = coords.lat;
      this.mapCenterLng = coords.lng;
    }
  }

  onZoomChange(zoom: number) {
    if (Number.isFinite(zoom)) {
      this.currentZoom = zoom;
    }
  }

  mapIdle() {
    this.isLoaded = false;
    this.pendingClusterListFromClick = false;
  }

  /**
   * AGM's (clusterClick) emits void and drops the Cluster object.
   * Bind native MarkerClusterer clusterclick and snapshot markers immediately
   * (geographic clusters can lose markers_ during map repaint/zoom).
   */
  bindNativeClusterClick() {
    if (this.clusterClickBinding) {
      return;
    }
    const clusterDirective = this.markerCluster as any;
    const clusterManager = clusterDirective && clusterDirective._clusterManager;
    if (!clusterManager || typeof clusterManager.getClustererInstance !== 'function') {
      return;
    }
    this.clusterClickBinding = true;
    clusterManager.getClustererInstance().then((clusterer: any) => {
      this.clusterClickBinding = false;
      if (!clusterer) {
        return;
      }
      // Same clusterer already bound
      if (this.boundClusterer === clusterer && this.clusterClickBound) {
        return;
      }
      this.boundClusterer = clusterer;
      this.clusterClickBound = true;

      // Prevent fitBounds-on-click which destroys the cluster before we can read it
      try {
        clusterer.zoomOnClick_ = false;
        if (typeof clusterer.setZoomOnClick === 'function') {
          clusterer.setZoomOnClick(false);
        }
      } catch (e) {
        // ignore
      }

      clusterer.addListener('clusterclick', (cluster: any) => {
        // CRITICAL: capture before any async/map repaint clears markers_
        const snapshot = this.captureClusterSnapshot(cluster);
        this.ngZone.run(() => {
          this.pendingClusterListFromClick = false;
          this.openStationsFromSnapshot(snapshot);
        });
      });
    }).catch(() => {
      this.clusterClickBinding = false;
    });
  }

  captureClusterSnapshot(raw: any): {
    markers: any[];
    count: number;
    center: { lat: number; lng: number } | null;
    bounds: any;
  } {
    const cluster = this.normalizeCluster(raw);
    const empty = { markers: [], count: 0, center: null, bounds: null };
    if (!cluster) {
      return empty;
    }

    // 1) Icon text first — still available even if markers_ is being cleared
    let count = 0;
    try {
      const icon = cluster.clusterIcon_ || cluster.b;
      const text = icon && icon.sums_ && icon.sums_.text;
      const parsed = parseInt(text, 10);
      if (Number.isFinite(parsed) && parsed > 0) {
        count = parsed;
      }
    } catch (e) {
      // ignore
    }

    // 2) Snapshot markers array immediately (copy)
    let markers: any[] = [];
    try {
      const rawMarkers = (typeof cluster.getMarkers === 'function' ? cluster.getMarkers() : null)
        || cluster.markers_
        || cluster.a
        || [];
      if (Array.isArray(rawMarkers)) {
        markers = rawMarkers.filter(Boolean).slice();
      }
    } catch (e) {
      markers = [];
    }
    if (!count && markers.length) {
      count = markers.length;
    }
    if (!count) {
      try {
        if (typeof cluster.getSize === 'function') {
          count = Number(cluster.getSize()) || 0;
        }
      } catch (e) {
        // ignore
      }
    }

    // 3) Center
    let center: { lat: number; lng: number } | null = null;
    try {
      const c = (typeof cluster.getCenter === 'function' ? cluster.getCenter() : null)
        || cluster.center_
        || cluster.d;
      if (c && typeof c.lat === 'function') {
        center = { lat: c.lat(), lng: c.lng() };
      }
    } catch (e) {
      center = null;
    }
    if (!center && markers.length) {
      let sumLat = 0;
      let sumLng = 0;
      let n = 0;
      markers.forEach((marker: any) => {
        try {
          const pos = marker.getPosition && marker.getPosition();
          if (pos) {
            sumLat += pos.lat();
            sumLng += pos.lng();
            n++;
          }
        } catch (e) {
          // skip
        }
      });
      if (n) {
        center = { lat: sumLat / n, lng: sumLng / n };
      }
    }

    // 4) Bounds (copy positions into a new LatLngBounds if possible)
    let bounds: any = null;
    try {
      if (typeof cluster.getBounds === 'function') {
        bounds = cluster.getBounds();
      }
    } catch (e) {
      bounds = null;
    }
    if (!bounds && markers.length && typeof google !== 'undefined') {
      try {
        bounds = new google.maps.LatLngBounds();
        markers.forEach((marker: any) => {
          const pos = marker.getPosition && marker.getPosition();
          if (pos) {
            bounds.extend(pos);
          }
        });
      } catch (e) {
        bounds = null;
      }
    }

    return { markers, count, center, bounds };
  }

  openStationsFromSnapshot(snapshot: {
    markers: any[];
    count: number;
    center: { lat: number; lng: number } | null;
    bounds: any;
  }) {
    if (!snapshot) {
      return;
    }

    // Preferred: exact markers that were in this cluster
    let matched = this.matchStationsFromMarkers(snapshot.markers || []);

    // If marker list was already cleared (common for spread-out geographic clusters),
    // rebuild using the cluster count + center so 10/12/13 still open with the right size.
    if (matched.length !== snapshot.count && snapshot.count > 0 && snapshot.center) {
      const byProximity = this.findClosestStations(snapshot.center.lat, snapshot.center.lng, snapshot.count);
      if (byProximity.length === snapshot.count) {
        matched = byProximity;
      } else if (!matched.length && byProximity.length) {
        matched = byProximity;
      }
    }

    if (!matched.length && snapshot.bounds) {
      let byBounds = this.findStationsInBounds(snapshot.bounds);
      if (snapshot.count > 0 && byBounds.length > snapshot.count && snapshot.center) {
        byBounds = this.findClosestStations(snapshot.center.lat, snapshot.center.lng, snapshot.count, byBounds);
      }
      if (byBounds.length > matched.length) {
        matched = byBounds;
      }
    }

    if (!matched.length && snapshot.center && snapshot.count > 0) {
      matched = this.findClosestStations(snapshot.center.lat, snapshot.center.lng, snapshot.count);
    }

    if (!matched.length) {
      return;
    }

    this.openClusterStationList(matched);
  }

  normalizeCluster(raw: any): any {
    if (!raw) {
      return null;
    }
    if (typeof raw.getMarkers === 'function' || Array.isArray(raw.markers_) || Array.isArray(raw.a)) {
      return raw;
    }
    if (raw.cluster_ && (typeof raw.cluster_.getMarkers === 'function' || raw.cluster_.markers_)) {
      return raw.cluster_;
    }
    if (raw.u && (typeof raw.u.getMarkers === 'function' || raw.u.markers_)) {
      return raw.u;
    }
    return raw;
  }

  /**
   * Map each Google marker in the cluster to exactly one station.
   * Prefer chargeboxId title, otherwise nearest unused station by marker position.
   */
  matchStationsFromMarkers(markers: any[]): any[] {
    const matched: any[] = [];
    const seen = new Set<string>();
    const unused = (Array.isArray(this.stations) ? this.stations : []).slice();

    (markers || []).forEach((marker: any) => {
      if (!marker || !unused.length) {
        return;
      }

      let stationIndex = -1;

      try {
        const title = typeof marker.getTitle === 'function' ? String(marker.getTitle() || '') : '';
        if (title) {
          stationIndex = unused.findIndex(s => String(s.chargeboxId) === title);
        }
      } catch (e) {
        stationIndex = -1;
      }

      if (stationIndex < 0 && typeof marker.getPosition === 'function') {
        try {
          const pos = marker.getPosition();
          if (pos) {
            const lat = pos.lat();
            const lng = pos.lng();
            const byKey = this.stationByPositionKey.get(this.positionKey(lat, lng));
            if (byKey) {
              stationIndex = unused.findIndex(s => String(s.chargeboxId) === String(byKey.chargeboxId));
            }
            if (stationIndex < 0) {
              stationIndex = this.findNearestStationIndex(unused, lat, lng, Number.POSITIVE_INFINITY);
            }
          }
        } catch (e) {
          stationIndex = -1;
        }
      }

      if (stationIndex < 0) {
        return;
      }

      const station = unused.splice(stationIndex, 1)[0];
      if (!station || seen.has(String(station.chargeboxId))) {
        return;
      }
      seen.add(String(station.chargeboxId));
      matched.push(station);
    });

    return matched;
  }

  findNearestStationIndex(candidates: any[], lat: number, lng: number, maxDistance: number): number {
    let bestIndex = -1;
    let bestDistance = maxDistance;
    candidates.forEach((station, index) => {
      const sLat = Number(station.latitude);
      const sLng = Number(station.longitude);
      if (!Number.isFinite(sLat) || !Number.isFinite(sLng)) {
        return;
      }
      const distance = Math.hypot(sLat - lat, sLng - lng);
      if (distance <= bestDistance) {
        bestIndex = index;
        bestDistance = distance;
      }
    });
    return bestIndex;
  }

  findClosestStations(lat: number, lng: number, count: number, pool?: any[]): any[] {
    const source = Array.isArray(pool) && pool.length
      ? pool
      : (Array.isArray(this.stations) ? this.stations : []);
    if (!count || count < 1) {
      return [];
    }
    return source
      .map(station => ({
        station,
        distance: Math.hypot(Number(station.latitude) - lat, Number(station.longitude) - lng)
      }))
      .filter(item => Number.isFinite(item.distance))
      .sort((a, b) => a.distance - b.distance)
      .slice(0, count)
      .map(item => item.station);
  }

  findStationsInBounds(bounds: any): any[] {
    if (!bounds || typeof bounds.contains !== 'function' || typeof google === 'undefined') {
      return [];
    }
    const sourceStations = Array.isArray(this.stations) ? this.stations : [];
    return sourceStations.filter(station => {
      const lat = Number(station.latitude);
      const lng = Number(station.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return false;
      }
      try {
        return bounds.contains(new google.maps.LatLng(lat, lng));
      } catch (e) {
        return false;
      }
    });
  }

  openClusterStationList(stations: any[]) {
    this.clusterStations = stations.slice().sort((a, b) =>
      String(a.name || a.chargeboxId).localeCompare(String(b.name || b.chargeboxId))
    );
    this.showClusterList = true;
    this.openedFromClusterList = false;
    this.stationFiltered = {};
    this.flagDetails = true;
    this.disableStationDetails = !this.userInfoService.isTabExists(MenuRouteID.STATIONS);
    this.isLoaded = false;
    this.cdr.detectChanges();
  }

  onClusterClick() {
    this.bindNativeClusterClick();
    this.pendingClusterListFromClick = true;
  }

  selectClusterStation(station: any) {
    if (!station || !station.chargeboxId) {
      return;
    }
    this.showClusterList = false;
    this.openedFromClusterList = this.clusterStations.length > 0;
    this.isLoaded = true;
    this.stationService.getstationlistbyid(station.chargeboxId).subscribe((resp: any) => {
      this.isLoaded = false;
      this.setStationsMapDetails(resp);
    }, err => {
      this.isLoaded = false;
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    });
  }

  backToClusterList() {
    if (!this.clusterStations.length) {
      this.closeDetailsPanel();
      return;
    }
    this.showClusterList = true;
    this.openedFromClusterList = false;
    this.stationFiltered = {};
  }

  closeDetailsPanel() {
    this.flagDetails = false;
    this.showClusterList = false;
    this.openedFromClusterList = false;
    this.clusterStations = [];
    this.stationFiltered = [];
  }

  getIcon(amenity) {
    return this.chargeboxService.getAmenitiesIcon(amenity);
  }

  redirectStationDetails(chargeboxId: any) {
    !!chargeboxId && this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(chargeboxId), "routedName": 'map', } });
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.STATION_DETAILS_MAP)
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          console.info("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: any) => {
          console.error(error);
          this.lat = environment.branding.mapInfo.lat;
          this.lng = environment.branding.mapInfo.lng;
        });

    } else {
      this.lat = environment.branding.mapInfo.lat;
      this.lng = environment.branding.mapInfo.lng;
      this.toastr.error(this.translate.instant('mapError'));
    }
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.authenticationService.setShowButton(false);
    this.reloadSub && this.reloadSub.unsubscribe();
  }

  onButtonClick() {
    // Same outcome as browser refresh: tear down AGM map/clusterer, then reload stations.
    // Updating the stations array alone leaves stale MarkerClusterer pins (wrong counts/colors).
    this.subscription && this.subscription.unsubscribe();
    this.subscription = new Subscription();

    this.userInfoService.userDetails.prefCountry === 'LK' ? this.zoom = 9 : this.zoom = 5;
    this.currentZoom = this.zoom;
    this.lat = environment.branding.mapInfo.lat;
    this.lng = environment.branding.mapInfo.lng;
    this.closeDetailsPanel();

    this.stations = [];
    this.rebuildStationLookup();
    this.clusterClickBound = false;
    this.clusterClickBinding = false;
    this.boundClusterer = null;

    this.showMap = false;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.showMap = true;
      this.cdr.detectChanges();
      this.getLocation();
      this.getStations();
    }, 0);
  }

  trackByChargeboxId(_index: number, station: any): string {
    return station && station.chargeboxId != null ? String(station.chargeboxId) : String(_index);
  }

  appendExtension(fileName: string, extension: string = ".png"): string {
    return fileName.toLowerCase() + extension;
  }

  checkInputColor(inputString) {
    const inputStringLower = inputString.toLowerCase();
    return this.stationColors.includes(inputStringLower);
  }
}
